/* eslint-disable max-lines */ //TODO Refactor Max lines
export const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex="0"]';

export abstract class TabOrderFocusSuperDirective {
  protected isPrimaryNav(target: HTMLElement): boolean {
    return (
      target.getAttribute('role') === 'tab' &&
      !!target.closest('#mach-core-header-nav-primary-list')
    );
  }

  protected isBookingTab(target: HTMLElement): boolean {
    return (
      target.getAttribute('role') === 'tab' &&
      !!target.closest('#mach-core-widget-tabs-section')
    );
  }

  protected getHotelLinkIfLastInput(target: HTMLElement): HTMLElement | null {
    const inputs = Array.from(
      document.querySelectorAll<HTMLElement>(
        '#mach-core-trip-search-content input:not([type="hidden"])'
      )
    ).filter((el) => el.offsetParent !== null);
    return inputs[inputs.length - 1] === target
      ? document.querySelector<HTMLElement>('#mach-core-ancillary-hotel-link')
      : null;
  }

  protected isAdvancedSearchToggle(target: HTMLElement): boolean {
    return (
      target.tagName === 'A' &&
      target.getAttribute('role') === 'button' &&
      !!target.closest('.home-book-widget-desktop')
    );
  }

  protected isAdvancedSearchCollapsed(): boolean {
    return !document.querySelector(
      '.home-book-widget-desktop .link-arrow-icon-expanded'
    );
  }

  protected isKnownSubmitId(target: HTMLElement): boolean {
    return target.id === 'mach-core-trip-search-submit';
  }

  protected isButtonPrimaryInWidgets(target: HTMLElement): boolean {
    return (
      target.tagName === 'BUTTON' &&
      target.classList.contains('button-primary') &&
      !!target.closest('#mach-core-header-widgets')
    );
  }

  protected firstVisible(scope: Element | null): HTMLElement | undefined {
    if (!scope) return undefined;
    return Array.from(scope.querySelectorAll<HTMLElement>(FOCUSABLE)).find(
      (el) => el.offsetParent !== null
    );
  }

  protected focusTopBar(): HTMLElement | null {
    return (
      document.querySelector<HTMLElement>('#signup-trigger') ??
      document.querySelector<HTMLElement>('#login-trigger') ??
      document.querySelector<HTMLElement>('#mach-core-login-flyout-details')
    );
  }

  protected focusAfterHeader(event: KeyboardEvent): void {
    const headerHost = document.querySelector<HTMLElement>('idp-header');
    const next = Array.from(
      document.querySelectorAll<HTMLElement>(FOCUSABLE)
    ).find((el) => !headerHost?.contains(el) && el.offsetParent !== null);
    if (next) {
      event.preventDefault();
      next.focus();
    }
  }

  protected focusEl(
    event: KeyboardEvent,
    el: HTMLElement | null | undefined
  ): void {
    if (el) {
      event.preventDefault();
      el.focus();
    }
  }

  protected focusFindFlights(event: KeyboardEvent): void {
    const ff = document.querySelector<HTMLElement>('#findFilghtsCta');
    if (ff) {
      ff.setAttribute('tabindex', '0');
      this.focusEl(event, ff);
    }
  }

  protected shiftHandleRoutePickerBtn(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    const ids = [
      'one-way-route-picker-origin-button',
      'one-way-route-picker-destination-button',
      'one-way-route-picker-swap-button'
    ];
    if (!ids.includes(target.id)) return false;
    this.focusEl(
      event,
      document.querySelector<HTMLElement>(
        '#mach-core-widget-tabs-section [role="tab"][aria-selected="true"]'
      )
    );
    return true;
  }

  protected shiftHandlePrimaryNav(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (!this.isPrimaryNav(target)) return false;
    event.preventDefault();
    const skipNav = document.querySelector<HTMLElement>(
      '[href="#main-content"], .skip-nav, [class*="skip"]'
    );
    skipNav?.focus();
    return true;
  }

  protected shiftHandleBookingTab(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (!this.isBookingTab(target)) return false;
    this.focusEl(
      event,
      document.querySelector<HTMLElement>(
        '#mach-core-header-nav-primary-list [role="tab"][tabindex="0"]'
      )
    );
    return true;
  }

  protected shiftHandleFirstWidgetField(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (!target.closest('#mach-core-header-widgets')) return false;
    const first = this.firstVisible(
      document.querySelector('#mach-core-header-widgets')
    );
    if (first !== target) return false;
    const bookingTab = document.querySelector<HTMLElement>(
      '#mach-core-widget-tabs-section [role="tab"][aria-selected="true"]'
    );
    const primaryNav = document.querySelector<HTMLElement>(
      '#mach-core-header-nav-primary-list [role="tab"][tabindex="0"]'
    );
    this.focusEl(event, bookingTab ?? primaryNav);
    return true;
  }

  protected shiftHandleShopWithMiles(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (target.id !== 'shopWithMiles') return false;
    this.focusEl(
      event,
      document.querySelector<HTMLElement>('.custom_dropdown_list_width')
    );
    return true;
  }

  protected shiftHandleFindFlights(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (target.id !== 'findFilghtsCta') return false;
    this.focusEl(
      event,
      document.querySelector<HTMLElement>(
        '.home-book-widget-desktop a[role="button"]'
      )
    );
    return true;
  }

  protected shiftHandleAmexLink(
    event: KeyboardEvent,
    target: HTMLElement
  ): boolean {
    if (target.id !== 'mach-core-widget-delta-amex-link') return false;
    this.focusEl(
      event,
      document.querySelector<HTMLElement>('#mach-core-header-search-button')
    );
    return true;
  }
}
